// src/App.js
import React, { useState, useEffect } from "react";

// Componentes comunes
import { Header, Footer, SocialSidebar } from "./components/common";

// Secciones principales
import { Hero, About, Projects } from "./sections";

function App() {
  const [currentSection, setCurrentSection] = useState(0);
  const [isScrolling, setIsScrolling] = useState(false);
  const sections = ['home', 'about', 'projects'];
  const totalSections = sections.length;

  useEffect(() => {
    let touchStartY = 0;
    let touchEndY = 0;

    const handleWheel = (e) => {
      if (isScrolling) return;

      e.preventDefault();

      if (e.deltaY > 0) {
        // Scroll down
        goToSection(currentSection + 1);
      } else {
        // Scroll up
        goToSection(currentSection - 1);
      }
    };

    const handleKeyDown = (e) => {
      if (isScrolling) return;

      if (e.key === 'ArrowDown' || e.key === 'PageDown') {
        e.preventDefault();
        goToSection(currentSection + 1);
      } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
        e.preventDefault();
        goToSection(currentSection - 1);
      }
    };

    const handleTouchStart = (e) => {
      touchStartY = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      touchEndY = e.touches[0].clientY;
    };

    const handleTouchEnd = () => {
      if (isScrolling) return;

      const deltaY = touchStartY - touchEndY;

      if (Math.abs(deltaY) > 50) {
        if (deltaY > 0) {
          // Swipe up
          goToSection(currentSection + 1);
        } else {
          // Swipe down
          goToSection(currentSection - 1);
        }
      }
    };

    window.addEventListener('wheel', handleWheel, { passive: false });
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchmove', handleTouchMove);
    window.addEventListener('touchend', handleTouchEnd);

    return () => {
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [currentSection, isScrolling]);

  const goToSection = (index) => {
    if (index < 0 || index >= totalSections || isScrolling) return;

    setIsScrolling(true);
    setCurrentSection(index);

    setTimeout(() => {
      setIsScrolling(false);
    }, 1000);
  };

  return (
    <div className="h-screen overflow-hidden">
      {/* Header fijo */}
      <Header goToSection={goToSection} currentSection={currentSection} />

      {/* Social Sidebar flotante */}
      <SocialSidebar />

      {/* Contenido principal con transición */}
      <main
        className="h-screen transition-transform duration-1000 ease-in-out"
        style={{
          transform: `translateY(-${currentSection * 100}vh)`,
        }}
      >
        <div id="home" className="h-screen">
          <Hero />
        </div>
        <div id="about" className="h-screen">
          <About />
        </div>
        <div id="projects" className="h-screen">
          <Projects />
        </div>
      </main>
    </div>
  );
}

export default App;
